import Transformer from '../transformer'
import SinisterTransformer from './SinisterTransformer'

import { shortDate, money, fromNowDate, timeBetween2Dates } from '@/filters'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

export default class PackageTransformer extends Transformer {
  static fetch(pkg) {
    return {
      addDate: shortDate(pkg.add_date),
      folio: pkg.folio,
      validationDate: pkg.validation_date !== null ? shortDate(pkg.validation_date) : fromNowDate(pkg.add_date),
      validationTime: pkg.validation_date !== null ? timeBetween2Dates(pkg.add_date, pkg.validation_date) : 'false',
      ...pkg.status,
      relatedAffected: SinisterTransformer.fetchCollection(pkg.related_affected),
      sinisters: pkg.related_affected.length,
      total: money(pkg.total),
      exchangePrice: parseFloat(pkg.exchange_price),
      id: pkg.id,
    }
  }
  static send(pkg) {}
}


// WEBPACK FOOTER //
// ./src/transformers/extranet/PackageByIdTransformer.js